import { useSaveDashboard } from "./useWidgets";
import { appendPinnedWidget } from "../utils/fanHubProfile";

export const usePinDashboardWidget = () => {
  const { saveUserDashboard, getCurrentDashboard, isLoading } =
    useSaveDashboard("home");

  const pinWidget = async (widget) => {
    const current = await getCurrentDashboard();
    if (!current.success) {
      return current;
    }
    const layout = appendPinnedWidget(current.data?.layout, widget);
    return saveUserDashboard(layout, current.data?.gridConfig);
  };

  return { pinWidget, isPinning: isLoading };
};
